import { render } from "./SubmitButton.vue?vue&type=template&id=4e486aee&scoped=true"
const script = {}

import "./SubmitButton.vue?vue&type=style&index=0&id=4e486aee&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-4e486aee"

export default script